//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ACTION_RESET_FOCUSED_PRODUCT_TILE } from '@/scripts/store/plp/actions'
import { createNamespacedHelpers } from 'vuex'

const { mapActions: mapActionsPlp } = createNamespacedHelpers('plp')

export default {
  name: 'RbLoadMore',
  props: {
    totalNumberOfProducts: {
      type: Number,
      required: true,
    },
    products: {
      type: Array,
      required: true,
    },
  },
  computed: {
    infoLabel() {
      return this.$t('plp.load_more_info')
        .replace(/%s/i, this.products.length)
        .replace(/%s/i, this.totalNumberOfProducts)
    },
  },
  methods: {
    ...mapActionsPlp({
      resetFocusedTileId: ACTION_RESET_FOCUSED_PRODUCT_TILE,
    }),
    onClick(event) {
      this.$emit('loadMoreProducts', event)
    },
  },
}
